module.exports = __webpack_public_path__ + "img/signatures_white.c0d79c80.svg";